import { isKO, useSite, isJA } from '@/store'

// 根据用户配置生成的完整的水印配置
export interface BlobData {
  url: string,
  blob?: Blob
}
interface WaterMarkConfig {
  src: string
  target: HTMLElement | HTMLImageElement
  image: string,
  success(data: BlobData): void
  onError(): void;
}

export const useWaterMark = async (src: string, image = 'https://static-jp.theckb.com/static-asset/client/mark_logo.png'): Promise<BlobData> => {
  if (!isJA()) {
    return await { url: src }
  }
  return new Promise((resolve, reject) => {
    createImage(src).then(target => {
      image2image({
        src,
        image,
        success: (res: BlobData) => {
          resolve({ url: res.url, blob: res.blob })
        },
        onError: () => {
          resolve({ url: src })
        },
        target
      })
    }).catch(() => {
      resolve({ url: src })
    })
  })
}

const image2image = async (config: WaterMarkConfig) => {
  const { image, target, success, onError } = config
  try {
    const [canvas, ctx] = createCanvas(target as HTMLImageElement)
    const { width, height } = target as HTMLImageElement

    const imageDom = await createImage(image)
    const { width: imageDomWidth, height: imageDomHeight } = imageDom
    ctx.drawImage(target as HTMLImageElement, 0, 0, width, height)
    const baseScale = 0.6
    const scale = width / 10 / imageDomWidth >= baseScale ? width / 10 / imageDomWidth : baseScale

    const w = 20
    const h = 20
    ctx.drawImage(imageDom, w, h, imageDomWidth * scale, imageDomHeight * scale)
    canvas.toBlob((blob) => {
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        (target as HTMLImageElement).src = url
        success && success({ url, blob })
      }
    })
  } catch (error) {
    onError && onError()
  }
}

/**
 * @description 根据图片的src width height生成图片dom元素
 * @param src 图片的src
 * @param width 图片的宽度
 * @param height 图片的高度
 * @returns 图片dom元素
 */
const createImage: (
  src: string,
  width?: number,
  height?: number
) => Promise<HTMLImageElement> = async (src, width, height) => {
  const img = new Image(width, height)
  img.setAttribute('crossorigin', 'crossorigin')
  img.src = src
  const imageDom = await new Promise<HTMLImageElement | null>((resolve) => {
    img.onload = () => {
      resolve(img)
    }
    img.onerror = () => {
      resolve(null)
    }
  })

  if (!imageDom) {
    throw new Error(`An error occurred while loading image (src: ${src} )`)
  }
  return imageDom
}

/**
 * @description 将图片dom元素转换成canvas
 * @param image 图片dom元素
 * @returns [canvas, Context]
 */

const createCanvas: (
  image: HTMLImageElement
) => [HTMLCanvasElement, CanvasRenderingContext2D] = (image) => {
  const { width, height } = image

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('Not exist: document.createElement(\'canvas\').getContext(\'2d\')')
  }
  ctx.drawImage(image, 0, 0, width, height)
  return [canvas, ctx]
}
